import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AnimatedSection from "../../components/AnimatedSection/AnimatedSection";
import ServiceCard from "../../components/ServiceCard/ServiceCard";
import GalleryStrip from "../../components/GalleryStrip/GalleryStrip";
import { SERVICES } from "../../data/services";
import "./ServiceDetail.css";

function ServiceDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const service = SERVICES.find((s) => s.id === id);

  if (!service) {
    return (
      <div className="not-found">
        <p>{t("service_detail.not_found")}</p>
        <button className="btn-outline" onClick={() => navigate("/services")}>{t("service_detail.back")}</button>
      </div>
    );
  }

  const related = SERVICES.filter((s) => s.id !== id).slice(0, 3);

  return (
    <div className="service-detail" style={{ paddingTop: 66 }}>

      {/* Hero */}
      <div className="service-detail__hero">
        <img src={service.image} alt={`${t(`services_data.${service.id}.title`, service.title)} — SK Associate`} className="service-detail__hero-bg" />
        <div className="service-detail__hero-overlay" />
        <div className="service-detail__hero-content container">
          <button className="service-detail__back" onClick={() => navigate("/services")}>{t("service_detail.back")}</button>
          <span className="badge">{t(`services_data.${service.id}.subtitle`, service.subtitle)}</span>
          <h1 className="service-detail__title">{t(`services_data.${service.id}.title`, service.title)}</h1>
        </div>
      </div>

      {/* Content */}
      <section className="section" style={{ background: "var(--bg2)" }}>
        <div className="container service-detail__grid detail-grid">
          <AnimatedSection>
            <div className="service-detail__main">
              <h2 className="service-detail__h2">{t("service_detail.overview")}</h2>
              <p className="service-detail__desc">{t(`services_data.${service.id}.description`, service.description)}</p>

              <h3 className="service-detail__h3">{t("service_detail.process")}</h3>
              <div className="service-detail__steps">
                {t(`services_data.${service.id}.steps`, { returnObjects: true, defaultValue: service.steps }).map((step, i) => (
                  <div key={i} className="process-step">
                    <div className="step-num">{i + 1}</div>
                    <span className="step-text">{step}</span>
                  </div>
                ))}
              </div>

              <GalleryStrip images={service.gallery} title={t("service_detail.gallery")} />
            </div>
          </AnimatedSection>

          <AnimatedSection delay={0.2}>
            <div className="sidebar-card">
              <h3 className="service-detail__sidebar-title">{t("service_detail.benefits")}</h3>
              {t(`services_data.${service.id}.benefits`, { returnObjects: true, defaultValue: service.benefits }).map((b) => (
                <div key={b} className="benefit-item">
                  <span className="check">✓</span>
                  <span>{b}</span>
                </div>
              ))}

              <div className="service-detail__sidebar-cta">
                <h4 className="service-detail__h4">{t("service_detail.cta_title")}</h4>
                <button className="btn-primary" style={{ width: "100%" }} onClick={() => navigate("/contact")}>
                  {t("service_detail.cta_btn")}
                </button>
              </div>

              <div className="service-detail__sidebar-img">
                <img src={service.gallery[1]} alt={t(`services_data.${service.id}.title`, service.title)} />
              </div>
            </div>
          </AnimatedSection>
        </div>
      </section>

      {/* Related services */}
      <section className="section" style={{ background: "var(--bg)" }}>
        <div className="container">
          <h2 className="section-title" style={{ marginBottom: 28 }}>{t("service_detail.related")}</h2>
          <div className="grid-auto">
            {related.map((s) => <ServiceCard key={s.id} service={s} />)}
          </div>
        </div>
      </section>

    </div>
  );
}

export default ServiceDetail;
